/// <reference path="../positioning/positioning.ts" />
/// <reference path="../dropdown/dropdown.ts" />
/// <reference path="../htmlhelpers/htmlhelpers.ts" />

namespace Teva {
    export class ColorPicker {
        static Init($Container: any = null): void {
            $("input.colorpicker:not(.colorpicker-initialized)", $Container).each(function () {
                this.addClass("colorpicker-initialized");
                new ColorPicker($(this));
            });
        }

        static PageLoad() {
            $(document).trigger("click.colorpicker-hide");
        }

        constructor($Input) {
            var Instance = this;
            $Input.wrap($(document.createElement('div'))
                .addClass("teva-colorpicker"));
            Instance.$Container = $Input.parent();
            var $SelectedBoxContainer = $(document.createElement('div')
                .addClass("teva-colorpicker-selectedbox-container"))
                .appendTo(Instance.$Container);
            Instance.$SelectedBox = $(document.createElement('div')
                .addClass("teva-colorpicker-selectedbox"))
                .appendTo($SelectedBoxContainer);
            if ($Input[0].value == "" && $Input[0].placeholder != "")
                Instance.$SelectedBox.css("background-color", $Input[0].placeholder);
            else
                Instance.$SelectedBox.css("background-color", $Input[0].value);
            Instance.$Input = $Input;
            Instance.$Input
                .data("colorpicker", this)
                .on("change input", function () {
                    if (this.value == "" && this.placeholder != "")
                        Instance.$SelectedBox.css("background-color", this.getAttribute("placeholder"));
                    else
                        Instance.$SelectedBox.css("background-color", this.value);
                    return true;
                })
                .on("click.colorpicker, focus.colorpicker", function () {
                    return Instance.Click()
                });
            Instance.$Container.on("click.colorpicker", function () {
                return Instance.Click()
            });
        }

        Click() {
            var Instance = this;
            Teva.Dropdown.Hide();
            $(document).trigger("click.colorpicker-hide");
            Instance.ShowMenu();
            return false;
        }

        ShowMenu() {
            var Instance = this;
            Instance.CreateMenu();

            $(document.body).append(Instance.$Menu);

            Teva.Positioning.PositionBelow_Start(Instance.$Menu, Instance.$Input, "colorpicker");
            Instance.$Menu.show();
            $(document).on("click.colorpicker-hide", function (Event) {
                if ($(Event.target).closest(Instance.$Menu).length != 0)
                    return;
                Instance.HideMenu();
            });
            $(document).on("keydown.colorpicker-hide", function () {
                Instance.HideMenu();
            });
        }

        HideMenu() {
            var Instance = this;
            if (Instance.$Menu != null)
                Instance.$Menu.remove();
            Teva.Positioning.PositionBelow_Stop(Instance.$Input, "colorpicker");
            Instance.$Menu = null;
            Instance.$Input.data("colorpicker", null);
            $(document).off("click.colorpicker-hide");
            $(document).off("keydown.colorpicker-hide");
        }

        CreateMenu() {
            var Instance = this;
            if (Instance.$Menu != null)
                return;

            Instance.$Menu = $(document.createElement('div')
                .addClass("teva-colorpicker-menu"));

            Instance.$Menu.append($(document.createElement('div')
                .addClass("teva-colorpicker-menu-remove"))
                .on("click", function () {
                    Instance.$Input.val("").trigger("change");
                    Instance.HideMenu();
                    return false;
                }));
            Instance.$Menu.append($(document.createElement('div')
                .addClass("teva-colorpicker-menu-close"))
                .on("click", function () {
                    Instance.HideMenu();
                    return false;
                }));
            Instance.$Menu.append($(document.createElement('div')
                .addClass("teva-colorpicker-menu-header"))
                .text("בחירת צבע"));

            var $Options = $(document.createElement('div')
                .addClass("teva-colorpicker-menu-options"))
                .appendTo(Instance.$Menu);

            var Colors = [
                "#FFFFFF", "#000000", "#EEECE1", "#1F497D", "#4F81BD", "#C0504D", "#9BBB59", "#8064A2", "#4BACC6", "#F79646",
                "#F2F2F2", "#7F7F7F", "#DDD9C3", "#C6D9F0", "#DBE5F1", "#F2DCDB", "#EBF1DD", "#E5E0EC", "#DBEEF3", "#FDEADA",
                "#D8D8D8", "#595959", "#C4BD97", "#8DB3E2", "#B8CCE4", "#E5B9B7", "#D7E3BC", "#CCC1D9", "#B7DDE8", "#FBD5B5",
                "#BFBFBF", "#3F3F3F", "#938953", "#548DD4", "#95B3D7", "#D99694", "#C3D69B", "#B2A2C7", "#92CDDC", "#FAC08F",
                "#A5A5A5", "#262626", "#494429", "#17365D", "#366092", "#953734", "#76923C", "#5F497A", "#31859B", "#E36C09",
                "#7F7F7F", "#0C0C0C", "#1D1B10", "#0F243E", "#244061", "#632423", "#4F6128", "#3F3151", "#205867", "#974806",
                "#C00000", "#FF0000", "#FFC000", "#FFFF00", "#92D050", "#00B050", "#00B0F0", "#0070C0", "#002060", "#7030A0"
            ]

            var SelectedColor = Instance.$Input.val();
            for (var i = 0; i < Colors.length; i++) {
                $(document.createElement('div'))
                    .addClass("teva-colorpicker-menu-option")
                    .css("background-color", Colors[i])
                    .data("color", Colors[i])
                    .addClass(Colors[i] == SelectedColor ? "teva-colorpicker-menu-option-selected" : null)
                    .appendTo($Options);
            }
            $Options.on("click", ".teva-colorpicker-menu-option", function () {
                $Options.find(".teva-colorpicker-menu-option-selected").removeClass("teva-colorpicker-menu-option-selected");
                this.addClass("teva-colorpicker-menu-option-selected");
                Instance.$Input.val($(this).data("color")).trigger("change");
                Instance.HideMenu();
                return false;
            });
        }

        $Container: any;
        $SelectedBox: any;
        $Input: any;
        $Menu: any;
    }
}

$(document).on("Teva.Init", function () {
    Teva.ColorPicker.Init();
});
